import { QueryClient } from '@tanstack/react-query'
import axios from 'axios'

const shouldRetryQuery = (failureCount: number, error: unknown) => {
  if (failureCount >= 1) return false

  if (!axios.isAxiosError(error)) return false

  const status = error.response?.status
  return status === undefined || status >= 500
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
})
